module.exports = __webpack_public_path__ + "static/media/turnOffAllAlerts.493f09a2.svg";